import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import usePageProps from '@/routes/usePageProps';
import GoogleMapPage from '@/pages/StoreMap';



const GoogleMapRoute: React.FC<RouteComponentProps> = props => {
  const pageProps = usePageProps({ props });

  if (pageProps.reducersState.app.loadingPlatformConfig) {
    return null;
  }

  return <GoogleMapPage {...pageProps} />
};

export default GoogleMapRoute;

